<script>
// Item reutilizável de lista: pílula cinza-clara com ícone à esquerda + texto.
// Recebe `icon` (nome do icon-svg), `iconColor` e `text`. O slot default permite
// complementos (ex.: "— responsável" nos próximos passos). Texto via az-text-*.
export default {
  name: 'TranscriptSummaryItem',
  props: {
    icon: { type: String, default: '' },
    iconColor: { type: String, default: '#8E8E8E' },
    iconSize: { type: [String, Number], default: 16 },
    text: { type: String, default: '' },
    // Inverte o esquema branco/cinza: dentro de um card já branco (inverted),
    // o item vira cinza pra manter a hierarquia visual.
    inverted: { type: Boolean, default: false },
  },
}
</script>

<template>
  <div
    class="transcript-summary-item"
    :class="{ 'transcript-summary-item--inverted': inverted }"
  >
    <icon-svg
      v-if="icon"
      :name="icon"
      :size="iconSize"
      :color="iconColor"
      class="mr-2 flex-shrink-0"
    />
    <span class="az-text-primary az-size-12">
      {{ text }}<slot />
    </span>
    <!-- Conteúdo opcional empurrado para a extrema direita (ex.: chip do responsável) -->
    <div
      v-if="$slots.right"
      class="ml-auto pl-3 flex-shrink-0 d-flex align-center"
    >
      <slot name="right" />
    </div>
  </div>
</template>

<style lang="sass" scoped>
.transcript-summary-item
  display: flex
  align-items: center
  background: var(--white)
  border: 1px solid #F0F1F3
  border-radius: 8px
  padding: 8px 12px

  // Dentro de um card branco (inverted), o item vira cinza.
  &--inverted
    background: #F8F9FA
</style>
